import React from "react";
import { changeDriverDeparture } from "../lib/driverPortal.js";
import { publishOrderDataChange } from "../utils/orderDataSync.js";

export default function useDriverDepartureAction({ scopeKey, dispatchDate, dispatchPeriod, previewDriverUserId, refresh,
  simulationScopeKey = scopeKey, simulationAvailable = false }) {
  const [state, setState] = React.useState({ pending: false, error: "" });
  const [testScope, setTestScope] = React.useState(null);
  const [simulation, setSimulation] = React.useState(null);
  const current = React.useRef(scopeKey);
  const inFlight = React.useRef(false);
  current.current = scopeKey;
  React.useEffect(() => { setState({ pending: false, error: "" }); setSimulation(null); }, [scopeKey]);
  React.useEffect(() => { setTestScope(null); setSimulation(null); }, [simulationScopeKey, simulationAvailable]);
  const testMode = simulationAvailable && testScope === simulationScopeKey;
  const activeSimulation = testMode && simulation?.scopeKey === scopeKey ? simulation : null;
  async function change(action, stop, onSuccess, simulatedDepartureAt = null) {
    if (inFlight.current) return;
    if (!stop?.visit_key) {
      setState({ pending: false, error: "Le départ de cet arrêt est indisponible. Rechargez le portail." });
      return;
    }
    inFlight.current = true;
    setState({ pending: true, error: "" });
    try {
      await changeDriverDeparture({ truck_id: stop.truck_id, visit_key: stop.visit_key,
        publication_revision: stop.publication_revision, expected_version: stop.version, action,
        ...(simulatedDepartureAt ? { simulated_departure_at: simulatedDepartureAt } : {}) },
      { dispatchDate, dispatchPeriod, previewDriverUserId });
      publishOrderDataChange("driver-portal");
      const next = await refresh();
      if (current.current === scopeKey) {
        setState({ pending: false, error: next ? "" : "Modification enregistrée. Actualisez le portail pour poursuivre." });
        if (next) onSuccess?.();
      }
    } catch (error) {
      if (current.current === scopeKey) setState({ pending: false, error: error.message || "Impossible d’enregistrer le départ. Réessayez." });
    } finally { inFlight.current = false; }
  }
  function setTestMode(enabled) {
    if (inFlight.current) return;
    setTestScope(enabled && simulationAvailable ? simulationScopeKey : null);
    setSimulation(null);
    setState({ pending: false, error: "" });
  }
  function requestDeparture(stop, label, onSuccess) {
    if (inFlight.current) return;
    if (testMode && stop?.visit_key) {
      setState({ pending: false, error: "" });
      setSimulation({ scopeKey, stop, label, onSuccess });
    } else void change("depart", stop, onSuccess);
  }
  function confirmSimulation(value) {
    if (!activeSimulation) return;
    void change("depart", activeSimulation.stop, () => {
      setSimulation(null);
      activeSimulation.onSuccess?.();
    }, value);
  }
  return { ...state, change, requestDeparture, simulationAvailable, testMode, setTestMode,
    simulation: activeSimulation, confirmSimulation,
    closeSimulation: () => { if (!inFlight.current) setSimulation(null); } };
}
